import { Component, ChangeDetectionStrategy } from '@angular/core';

import { priorityColorMap } from '@core/ask-hr-templates-util';
import type { AskTicketBoardItem, AskTicketPriority } from '@core/ask-hr-types';
import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { EMPTY_CELL, IconComponent } from '@core/user-interface-legacy';

import { AsksColumnId, defineAskTableColumn } from './types';

/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/consistent-type-assertions */

@Component({
  selector: 'priority-column',
  imports: [IconComponent],
  template: `
    <rt-icon name="flag" [colorToken]="priorityColorMap[priority]" />
    {{ priorityTranslations[priority] }}
  `,
  inputs: PriorityColumnComponent.NgInputs,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    `,
  ],
})
export class PriorityColumnComponent {
  public static NgInputs = ['priority' as const];

  protected readonly priorityColorMap = priorityColorMap;
  protected readonly priorityTranslations: Record<AskTicketPriority, string> = {
    low: injectTranslate()('tlc.ask_hr.requests.priority_levels.low'),
    normal: injectTranslate()('tlc.ask_hr.requests.priority_levels.normal'),
    high: injectTranslate()('tlc.ask_hr.requests.priority_levels.high'),
    urgent: injectTranslate()('tlc.ask_hr.requests.priority_levels.urgent'),
  };

  public priority: Exclude<AskTicketBoardItem['priority'], null>;
}

export const priorityColumn = defineAskTableColumn(() => ({
  id: AsksColumnId.Priority,
  label: injectTranslate()('tlc.ask_hr.requests.priority'),
  visible: true,
  geometry: {
    width: 200,
    minWidth: 150,
    autoFitProp: 'width',
  },
  options: {
    draggable: true,
    resizable: true,
    removable: false,
    sortable: true,
  },
  componentFactory: ({ row }) => {
    if (!row.priority) return EMPTY_CELL;

    return componentOutletConfigFactory(PriorityColumnComponent, {
      inputs: { priority: row.priority },
    });
  },
}));
